/**
 * INPUT TOKENS
 *
 * Custom additions are marked with "Custom" comments below.
 */
import { nbxVar as v } from '../../../tokens/generated/nbx-tokens.js';
import { SEMANTIC, type SemanticTokens } from '../semantic.js';

export function createInputTokens(s: SemanticTokens) {
  return {
    /** Base spacing for input fields */
    base: {
      paddingX: v('input.base.padding-x'), // --input-base-padding-x: var(--spacing-16)
      paddingY: v('input.base.padding-y'), // --input-base-padding-y: var(--spacing-16)
      gap: v('input.base.gap'), // --input-base-gap: var(--spacing-8)
      radius: v('input.base.radius'), // --input-base-radius: var(--radius-8)
      buttonSize: s.controlSize.md, // --input-base-button-size (2.75rem, steppers)
      buttonPadding: s.layout.gap.md, // --input-base-button-padding (0.5rem)
      iconSize: s.iconSizes.base, // --input-base-icon-size
      horizontalGap: s.layout.gap.md, // --input-base-horizontal-gap
      transition: s.transition.normal, // --input-base-transition
    },
    filtersTrigger: {
      height: v('spacing.56'),
      outlineWidth: '1px',
    },
    bg: s.surface.ground, // --input-bg: var(--surface-ground)
    bgHover: s.surface.ground, // --input-bg-hover: var(--surface-ground)
    bgFocus: s.border.secondary, // --input-bg-focus: var(--border-primary)
    bgDisabled: s.surface.disabled, // --input-bg-disabled: var(--surface-disabled)
    border: s.border.default, // --input-border: var(--border-default)
    borderFocus: s.border.focusInput, // --input-border-focus: var(--border-focus)
    fg: s.text.secondary, // --input-fg: var(--text-secondary)
    placeholder: s.text.muted, // --input-placeholder: var(--text-muted)
    addon: s.text.secondary,

    // ──── Custom tokens ────

    fgDisabled: s.text.disabled, // --input-fg-disabled: var(--text-disabled)
    borderInvalid: s.border.danger, // --input-border-invalid: var(--border-danger)
  };
}
export const inputTokens = createInputTokens(SEMANTIC);
